module.exports = __webpack_public_path__ + "media/images/reserve_top_mockups-48eb723043fc0b1d58e54baed1b6caaf.png";